import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUpdateBookMutation } from "../../features/api/apiSlice";
import { toastMsg } from "../../utils/toastMsg";

const Form = ({ book }) => {
  const {
    id,
    name: initialName,
    author: initialAuthor,
    thumbnail: initialThumbnaile,
    price: initialPrice,
    rating: initialRating,
    featured: initialFeatured,
  } = book || {};

  const navigate = useNavigate();

  const [updatedBook, { isLoading, isSuccess }] = useUpdateBookMutation();

  const [name, setName] = useState(initialName);
  const [author, setAuthor] = useState(initialAuthor);
  const [thumbnail, setThumbnail] = useState(initialThumbnaile);
  const [price, setPrice] = useState(initialPrice);
  const [rating, setRating] = useState(initialRating);
  const [featured, setFeatured] = useState(initialFeatured);

  console.log(name, author, thumbnail, price, rating, featured);
  const handleSubmit = (e) => {
    e.preventDefault();
    updatedBook({
      id,
      name,
      author,
      thumbnail,
      price,
      rating,
      featured,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      setName("");
      setAuthor("");
      setThumbnail("");
      setPrice("");
      setRating("");
      setFeatured(false);
      toastMsg("Book successfully Updated", "success");
      navigate("/");
    }
  }, [isSuccess, navigate]);

  return (
    <form className="book-form" onSubmit={handleSubmit}>
      <div className="space-y-2">
        <label htmlFor="lws-bookName">Book Name</label>
        <input
          required
          className="text-input"
          type="text"
          id="lws-bookName"
          name="name"
          onChange={(e) => setName(e.target.value)}
          value={name}
        />
      </div>

      <div className="space-y-2">
        <label htmlFor="lws-author">Author</label>
        <input
          required
          className="text-input"
          type="text"
          id="lws-author"
          name="author"
          onChange={(e) => setAuthor(e.target.value)}
          value={author}
        />
      </div>

      <div className="space-y-2">
        <label htmlFor="lws-thumbnail">Image Url</label>
        <input
          required
          className="text-input"
          type="text"
          id="lws-thumbnail"
          name="thumbnail"
          onChange={(e) => setThumbnail(e.target.value)}
          value={thumbnail}
        />
      </div>

      <div className="grid grid-cols-2 gap-8 pb-4">
        <div className="space-y-2">
          <label htmlFor="lws-price">Price</label>
          <input
            required
            className="text-input"
            type="number"
            id="lws-price"
            name="price"
            onChange={(e) => setPrice(e.target.value)}
            value={price}
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="lws-rating">Rating</label>
          <input
            required
            className="text-input"
            type="number"
            id="lws-rating"
            name="rating"
            min="1"
            max="5"
            onChange={(e) => setRating(e.target.value)}
            value={rating}
          />
        </div>
      </div>

      <div className="flex items-center">
        <input
          id="lws-featured"
          type="checkbox"
          name="featured"
          className="w-4 h-4"
          onChange={(e) => setFeatured(e.target.checked)}
          checked={featured}
        />
        <label htmlFor="lws-featured" className="ml-2 text-sm">
          {" "}
          This is a featured book{" "}
        </label>
      </div>

      <button
        type="submit"
        className="submit"
        id="lws-submit"
        disabled={isLoading}
      >
        Edit Book
      </button>
    </form>
  );
};

export default Form;
